import compose from 'lodash.flowright';
import { graphql, withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import WebGalleryPhotoGroup from './WebGalleryPhotoGroup';
import { openModal } from '../../../../actions/modal-actions';
import withFavoritePhotosMutations from '../../hoc/withFavoritePhotosMutations';
import { hasPurchasedAlbumSubscriptionsOnAlbum } from '../../utilities/web-galleries';
import { AccountPurchases } from '../../graphql/queries/account';
import {
  AlbumPhotoGroupForWebGallery,
  AlbumPhotoGroupForWebGalleryPhotos,
} from '../../graphql/queries/album-photo-group';

const withPhotoGroup = graphql(AlbumPhotoGroupForWebGallery, {
  options: ({ match }) => ({
    variables: {
      id: match.params.photoGroupId,
      for_web_gallery: true,
    },
  }),
  skip: ({ match }) => !match.params.photoGroupId,
  props: ({ data: { loading, albumPhotoGroup } }) => ({
    loading,
    photoGroup: albumPhotoGroup,
    album: albumPhotoGroup && albumPhotoGroup.album,
  }),
});

const withPhotoGroupPhotos = graphql(AlbumPhotoGroupForWebGalleryPhotos, {
  options: ({ match }) => ({
    variables: {
      id: match.params.photoGroupId,
      ignore_watermark: true,
      limit: 100,
      offset: 0,
      for_web_gallery: true,
    },
  }),
  skip: ({ match }) => !match.params.photoGroupId,
  props: ({ data: { fetchMore, albumPhotoGroup } }) => ({
    photos: albumPhotoGroup?.photos,
    loadMore() {
      return fetchMore({
        variables: {
          offset: albumPhotoGroup?.photos.records.length,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) {
            return previousResult;
          }

          const prevPhotoRecords =
            previousResult.albumPhotoGroup.photos.records;
          const fetchMorePhotoRecords =
            fetchMoreResult.albumPhotoGroup.photos.records;

          return {
            ...previousResult,
            albumPhotoGroup: {
              ...previousResult.albumPhotoGroup,
              photos: {
                ...previousResult.albumPhotoGroup.photos,
                count: prevPhotoRecords.length + fetchMorePhotoRecords.length,
                records: [...prevPhotoRecords, ...fetchMorePhotoRecords],
              },
            },
          };
        },
      });
    },
  }),
});

const withAccountPurchases = graphql(AccountPurchases, {
  props: ({ ownProps, data: { me } }) => ({
    forceAllowHiResDownloads: hasPurchasedAlbumSubscriptionsOnAlbum(
      me,
      ownProps.match.params.albumId,
    ),
  }),
  skip: ({ match, authenticated }) => !match.params.albumId || !authenticated,
});

const mapStateToProps = ({ webGalleryCart, auth }) => ({
  purchasedDownloads: webGalleryCart.purchasedDownloads,
  authenticated: auth.authenticated,
});

const mapDispatchToProps = dispatch => ({
  openModal: name => dispatch(openModal(name)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withPhotoGroup,
  withPhotoGroupPhotos,
  withFavoritePhotosMutations,
  withAccountPurchases,
  withApollo,
)(WebGalleryPhotoGroup);
